import { transformBrandDtos } from 'data/transformers/brand';
import { transformColorDtos } from 'data/transformers/color';
import { transformSizeDtos } from 'data/transformers/size';
export const transformStatuses = statusesDto => statusesDto.map(_ref => {
  let {
    id,
    title,
    explanation
  } = _ref;
  return {
    id,
    title,
    body: explanation
  };
});
export const transformColors = colorsDto => colorsDto.map(_ref2 => {
  let {
    id,
    title,
    code
  } = _ref2;
  return {
    id,
    title,
    code
  };
});
export const transformDynamicAttributes = attributes => (attributes === null || attributes === void 0 ? void 0 : attributes.map(_ref3 => {
  let {
    code,
    ids
  } = _ref3;
  return {
    field: code,
    value: ids
  };
})) || [];

function isCatalogPhotoDto(value) {
  return 'url' in value;
}

export const transformCatalogs = catalogsDto => {
  const transformedCatalogs = [];

  function catalogTransform(catalog, parentId) {
    const catalogIds = [];

    if (catalog.catalogs) {
      catalog.catalogs.forEach(child => {
        catalogTransform(child, catalog.id);
        catalogIds.push(child.id);
      });
    }

    const transformedCatalog = {
      id: catalog.id,
      code: catalog.code,
      parentId,
      catalogIds,
      url: catalog.url,
      title: catalog.title,
      restrictedToStatusId: catalog.restricted_to_status_id,
      isColorSelectShown: !!catalog.color_field_visibility,
      isSizeSelectShown: !!catalog.size_field_visibility,
      isBrandSelectShown: !!catalog.brand_field_visibility,
      isIsbnInputShown: !!catalog.isbn_field_visibility,
      isAuthorInputShown: !!catalog.author_field_visibility,
      isBookTitleInputShown: !!catalog.book_title_field_visibility,
      isMeasurementsSelectShown: !!catalog.measurements_field_visibility,
      sizeGroupId: catalog.size_group_id,
      unisexCatalogId: catalog.unisex_catalog_id,
      isVideoGameRatingSelectShown: !!catalog.video_game_rating_field_visibility,
      photo: isCatalogPhotoDto(catalog.photo) ? catalog.photo : null
    };
    transformedCatalogs.push(transformedCatalog);
  }

  catalogsDto.forEach(catalog => catalogTransform(catalog, 0));
  return transformedCatalogs;
};
export const transformPriceSuggestionsDto = _ref4 => {
  let {
    price_suggestion,
    similar_sold_items_present,
    display_type
  } = _ref4;
  return {
    min: price_suggestion ? Number(price_suggestion.minimum) : null,
    max: price_suggestion ? Number(price_suggestion.maximum) : null,
    currency: (price_suggestion === null || price_suggestion === void 0 ? void 0 : price_suggestion.currency) || null,
    hasSimilarItems: similar_sold_items_present,
    displayType: display_type || null
  };
};
export const transformBookDetails = _ref5 => {
  let {
    book_details
  } = _ref5;
  return {
    author: book_details.author,
    title: book_details.title
  };
};
export const transformItemAttributesToItemUploadDto = function transformItemAttributesToItemUploadDto(_ref6, assignedPhotos, dynamicAttributes, currency) {
  let {
    id,
    catalogId,
    colorIds,
    title,
    description,
    isUnisex,
    statusId,
    price,
    sizeId,
    brandId,
    brandTitle,
    isbn,
    packageSize,
    videoGameRatingId,
    measurementLength,
    measurementWidth
  } = _ref6;
  let tempUuid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  return {
    id,
    currency,
    temp_uuid: tempUuid,
    title,
    description,
    brand_id: brandId,
    brand: brandTitle,
    size_id: sizeId,
    catalog_id: catalogId,
    isbn,
    is_unisex: isUnisex,
    status_id: statusId,
    video_game_rating_id: videoGameRatingId,
    price,
    package_size_id: packageSize.id,
    shipment_prices: {
      domestic: packageSize.custom.domestic,
      international: packageSize.custom.international
    },
    color_ids: colorIds,
    assigned_photos: assignedPhotos,
    measurement_length: measurementLength,
    measurement_width: measurementWidth,
    item_attributes: dynamicAttributes === null || dynamicAttributes === void 0 ? void 0 : dynamicAttributes.map(attr => ({
      code: attr.field,
      ids: attr.value
    }))
  };
};
export const transformItemSuggestions = _ref7 => {
  let {
    brands,
    colors,
    sizes,
    catalogs
  } = _ref7;
  return {
    catalogs,
    brands: transformBrandDtos(brands),
    colors: transformColorDtos(colors),
    sizes: transformSizeDtos(sizes)
  };
};